function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Cloud Storage");

const SvgGcs = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  width: 128,
  height: 128,
  viewBox: "0 0 128 128",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M126.47,58.12l-26.3-45.74A11.56,11.56,0,0,0,90.31,6.5H37.7a11.55,11.55,0,0,0-9.86,5.88L1.53,58a11.48,11.48,0,0,0,0,11.44l26.3,46a11.77,11.77,0,0,0,9.86,6.09H90.3a11.73,11.73,0,0,0,9.87-6.06l26.3-45.74A11.73,11.73,0,0,0,126.47,58.12Z",
  style: {
    fill: "#4285f4"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.49,50.55,49.31,53.88l-7,7,6,6L42.36,77.3l44.2,44.2H90.3a11.73,11.73,0,0,0,9.87-6.06L118.5,83.56Z",
  style: {
    opacity: 0.070000000298023,
    isolation: "isolate"
  }
}), /*#__PURE__*/React.createElement("g", {
  id: "art"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M84.7,50.27H43.26A1.22,1.22,0,0,0,42,51.48v8.57a1.21,1.21,0,0,0,1.21,1.21H84.7a1.22,1.22,0,0,0,1.21-1.21V51.48a1.22,1.22,0,0,0-1.21-1.21m-6.41,8a2.48,2.48,0,1,1,2.48-2.48,2.48,2.48,0,0,1-2.48,2.48",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.7,66.74H43.26A1.22,1.22,0,0,0,42,68v8.57a1.22,1.22,0,0,0,1.21,1.21H84.7a1.22,1.22,0,0,0,1.21-1.21V67.95a1.22,1.22,0,0,0-1.21-1.21m-6.41,8a2.48,2.48,0,1,1,2.48-2.48,2.48,2.48,0,0,1-2.48,2.48",
  style: {
    fill: "#fff"
  }
}))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGcs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gcs.6ebac44d.svg";
export { ForwardRef as ReactComponent };